import {
    MERCHANT_LIST_INITIATED,
    MERCHANT_INITIATED,
    MERCHANT_LOADED,
    MERCHANT_FAILED,
    MERCHANT_LIST_LOADED,
    MERCHANT_COUNT_INITIATED,
    MERCHANT_COUNT_LOADED,
    MERCHANT_COUNT_FAILED,
    MERCHANT_DOC_INITIATED,
    MERCHANT_DOC_LOADED,
    MERCHANT_DOC_FAILED,
    MERCHANT_NAMELIST_INITIATED,
    MERCHANT_NAMELIST_LOADED,
    MERCHANT_NAMELIST_FAILED
  } from "../actions/MerchantAction";
  
  const initialState = {
    listdata: [],
    merchantList:[],
    data: [],
    merchantCount : {
      active_count : 0,
      inactive_count : 0,
      pending_count : 0,
      total_count : 0,
    },
    doDetails:{
      bankData : {
        date : '',
        text : ''
      },
      kycData : {
        date : '',
        text : ''
      },
      transData : {
        date : '',
        text : ''
      }
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const MerchantReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_LIST_INITIATED:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case MERCHANT_LIST_LOADED:
        return {
          ...state,
          loading: false,
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case MERCHANT_INITIATED:
        return { ...state, loading: true, error: null };
      case MERCHANT_LOADED:
        const updatedObj = Object.fromEntries(
          Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
        );
        return { ...state, loading: false, data: updatedObj };
      case MERCHANT_COUNT_INITIATED:
          return { ...state};
      case MERCHANT_COUNT_LOADED:
          return { ...state, merchantCount: action.payload };
      case MERCHANT_COUNT_FAILED:
          return { ...state };
      case MERCHANT_DOC_INITIATED:
          return { ...state};
      case MERCHANT_DOC_LOADED:
          return { ...state, doDetails: action.payload };
      case MERCHANT_DOC_FAILED:
          return { ...state };
      case MERCHANT_NAMELIST_INITIATED:
          return { ...state, merchantList : []};
      case MERCHANT_NAMELIST_LOADED:
          return { ...state, merchantList: action.payload };
      case MERCHANT_NAMELIST_FAILED:
          return { ...state };
      case MERCHANT_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantReducer;